// Require.js configuration
require.config({
    baseUrl: '/app',
    waitSeconds: 90,
    catchError:true,
    urlArgs: 'v=@@timestamp',
    shim: {
        'underscore': {
            exports: '_'
        },
        'backbone': {
            deps: ['underscore', 'jquery'],
            exports: 'Backbone'
        },
        'amplify': {
            exports: 'amplify'
        },
        'raven': {
            deps: ['tracekit'],
            exports: "Raven"
        },
        "classnames": {
            exports: "classNames"
        },

        // jquery plugins
        'bootstrap': ['jquery'],
        'ieShim': ['jquery'],
        'fastButton': ['jquery'],
        'chosen': ['jquery'],
        'form': ['jquery'],
        'parsley': ['jquery'],
        'datepicker' : ['jquery'],
        'timeago': ['jquery'],
        'tweetparse': ['jquery'],
        'open-new-tab' : ['jquery'],
        "clickOutside" : ["jquery"],

        // bootstrap plugins
        'bootstrapTransition' : ['jquery'],
        'bootstrapTooltip' : ['jquery'],
        'bootstrapAlert' :['bootstrapTransition', 'jquery'],
        'bootstrapModal' :['bootstrapTransition', 'jquery'],
        'bootstrapCollapse' :['bootstrapTransition', 'jquery'],
        'bootstrapPopover' : ['bootstrapTooltip', 'jquery'],
        'bootstrapTour' : ['bootstrapPopover', 'jquery'],
        'bootstrapTab' : ['jquery'],

        // dust
        'dustCompiler': ['dust'],
        'mainTmpl': ['dust'],

        //d3
        'd3legend' : ['d3'],
        'jqueryParse': {
            exports: 'jqueryParse'
        }
    },

    map: {
        "et_flux": {
            "React": "react"
        }
    },

    // Initialize the application with the main application file
    paths: {
        app:            "app",
        collections:    "collections",
        models:         "models",
        views:          "views",
        components:     "components",
        libs:           "../scripts/libs",
        helpers:        "helpers",
        ET:             "et",
        evertrue:       "evertrue",
        router:         "router",
        ViewManager:    "ViewManager",
        env:            "../config/env",

        // template managment paths
        templates:      "templates",
        mainTmpl:       "templates/templates",

        // libs
        et_flux:        "../components/et-flux/et-flux",
        client_decorator: "../components/client-decorator/decorator",
        jquery:         "../components/jquery/jquery",
        underscore:     "../components/underscore/underscore",
        react:          "../components/react/react-with-addons",
        reactDOM:       "../components/react/react-dom",
        reactDOMServer: "./components/react/react-dom-server",
        backbone:       "../components/backbone/backbone",
        amplify:        "../components/amplify/amplify.store",
        moment:         "../components/moment/moment",
        momentTimezone: "../components/moment-timezone/moment-timezone-with-data-2010-2020",
        tracekit:       "../components/tracekit/tracekit",
        raven:          "../components/raven-js/raven",
        classnames:     "../components/classnames/index",
        validator:      "../components/validator-js/validator",
        clickOutside:   "../scripts/libs/jquery.ba-outside-events",
        cookies:        "../components/cookies-js/cookies",
        numeral:        "../components/numeral/numeral",

        // compatability scripts
        ieShim:         "../scripts/plugins/ie-shim",

        // backbone plugins
        poller:         "../components/backbone-poller/backbone.poller",

        // jquery plugins
        chosen:         "../components/chosen/chosen.jquery",
        form:           "../components/jquery-form/jquery.form",
        deparam:           "../components/jquery-deparam/jquery-deparam",
        parsley:        "../components/parsleyjs/parsley",
        jqueryParse:     "../scripts/libs/jquery.parse.min",

        //aws
        aws:            "../scripts/libs/aws.min",

        // Bootstrap JS
        bootstrapAlert:      "../components/bootstrap/bootstrap-alert",
        bootstrapTransition: "../components/bootstrap/bootstrap-transition",
        bootstrapModal:      "../components/bootstrap/bootstrap-modal",
        bootstrapCollapse:   "../components/bootstrap/bootstrap-collapse",
        bootstrapTooltip:    "../components/bootstrap/bootstrap-tooltip",
        bootstrapPopover:    "../components/bootstrap/bootstrap-popover",
        bootstrapCarousel:   "../components/bootstrap/bootstrap-carousel",
        bootstrapTab:        "../components/bootstrap/bootstrap-tab",
        bootstrapDropdown:   "../components/bootstrap/bootstrap-dropdown",

        // Bootstrap plugins
        bootstrapTour:       "../scripts/plugins/bootstrap-tour",
        datepicker:          "../components/bootstrap-datepicker/bootstrap-datepicker",

        // template compiler
        // dust has always been finicky...lets test heavily before moving to bower
        dust:           "../scripts/libs/dust",
        dustCompiler:   "../scripts/libs/dust-compiler",

        // d3
        d3:             "../components/d3/d3",
        d3legend:       "../scripts/libs/d3/d3.legend",
        queue:          "../scripts/libs/d3/queue",

        // zeroclipboard
        zeroclipboard:  "../components/zeroclipboard/ZeroClipboard",

        // filesaver
        FileSaver:      "../../node_modules/file-saver/FileSaver",
        canvasToBlob:   "../scripts/libs/canvas-toBlob",

        // non-bower plugins
        plugins:        "../scripts/plugins",
        jsonformat:     "../scripts/plugins/jsonformat",
        fastButton:     "../scripts/plugins/google.fastbutton",

        // requirejs plugins
        async:          "../scripts/plugins/async",
        text:           "../scripts/plugins/text"
    }
});

define("common", function(){});

